import Vue from 'vue';
import VueRouter from 'vue-router';
import Guard from '@/services/middleware';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    name: 'Home',
    beforeEnter: Guard.auth,
    children: [
      {
        path: 'usuarios',
        name: 'UsersList',
        component: () => import('@/pages/users/users-list.vue'),
        meta: {
          title: 'Usuários',
          subtitle: 'Cadastre e gerencie os usuários da plataforma.',
        },
      },
      {
        path: 'usuarios/:id',
        name: 'UserDetails',
        props: true,
        component: () => import('@/pages/users/user-show.vue'),
      },
      {
        path: 'planos',
        name: 'PlansList',
        component: () => import('@/pages/plans/plans-list.vue'),
        meta: {
          title: 'Planos',
          subtitle: 'Cadastre e gerencie os planos da plataforma.',
        },
      },
      {
        path: 'cupons',
        name: 'CouponsList',
        component: () => import('@/pages/coupons/coupons-list.vue'),
        meta: {
          title: 'Cupons',
          subtitle: 'Cadastre e gerencie cupons de desconto para o checkout.',
        },
      },
      {
        path: 'indicacoes',
        name: 'ReferralLinksList',
        component: () => import('@/pages/referral-links/referral-links-list.vue'),
        meta: {
          title: 'Links de Indicação',
          subtitle: 'Cadastre links de indicação e acompanhe cadastros e conversões.',
        },
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/pages/auth/layout.vue'),
    children: [
      {
        path: '/',
        name: 'AuthLogin',
        component: () => import('@/pages/auth/login.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
